import React, { useState } from 'react';
import * as XLSX from 'xlsx';

const ExcelDownloadPage = () => {
  const [sheetData, setSheetData] = useState([]);

  const generateTestData = () => {
    const sheetData = [];
  
    const companyNames = [
      'Capgemini',
      'Mindtree',
      'Tech Mahindra',
      'TCS',
      'Hyland',
      'Infosys',
      'LTI',
      'Google',
      'Microsoft',
      'Zoho',
    ];
  
    for (let year = 2010; year <= 2023; year++) {
      const sheetName = year.toString();
      const sheetRows = [];
  
      for (let i = 0; i < companyNames.length; i++) {
        const companyName = companyNames[i];
        const placements = Math.floor(Math.random() * 29) + 2; // Random value between 2 and 30
        const maxStudents = Math.ceil(placements * 1.1); // 10% more than placements
        const totalStudents = Math.floor(Math.random() * (maxStudents - placements + 1)) + placements; // Random value between placements and maxStudents
  
        const rowData = {
          companyName,
          placements,
          Total_Students_Appeared: totalStudents,
        };
  
        sheetRows.push(rowData);
      }
  
      const sheetDataItem = {
        sheetName,
        data: sheetRows,
      };
  
      sheetData.push(sheetDataItem);
    }
  
    return sheetData;
  };
  

  const downloadExcelFile = () => {
    const workbook = XLSX.utils.book_new();

    sheetData.forEach((sheet) => {
      const { sheetName, data } = sheet;
      const worksheet = XLSX.utils.json_to_sheet(data);
      XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
    });

    const excelBuffer = XLSX.write(workbook, { type: 'buffer', bookType: 'xlsx' });
    const excelBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const downloadLink = URL.createObjectURL(excelBlob);

    const a = document.createElement('a');
    a.href = downloadLink;
    a.download = 'testdata.xlsx';
    a.click();
  };

  const handleGenerateClick = () => {
    const testData = generateTestData();
    setSheetData(testData);
  };

  return (
    <div>
      <h1>Excel Download Page</h1>
      <button onClick={handleGenerateClick}>Generate Excel</button>
      {sheetData.length > 0 && (
        <button onClick={downloadExcelFile}>Download Excel</button>
      )}
    </div>
  );
};

export default ExcelDownloadPage;
